import React from 'react'
import { Link } from 'react-router-dom'

export default function CourseItem({ imgSrc, imgAlt, courseTitle, CourseBrief,
    sessions, courseFees, courseDetails, courseHours }) {
    function scrollToTop() {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    }
    return <>
        {/* <!-- Section: Courses --> */}

        <div className="col-md-4">
            <div className="campaign bg-white mb-30">
                <div className="thumb">
                    {imgSrc ? <img src={imgSrc} alt={imgAlt} className="img-fullwidth" /> : <img src='images/project/13.jpg' alt={imgAlt} className="img-fullwidth" />}
                    {/* <img src='images/project/13.jpg' alt={imgAlt} className="img-fullwidth" /> */}
                    <div className="campaign-overlay"></div>
                </div>
                <div className="campaign-details clearfix p-15 pt-10 pb-10">
                    <h6 className="text-theme-colored2 font-weight-500 mb-0">{courseHours} Hours</h6>
                    <h5 className="font-weight-700 mt-0"><Link to={courseDetails} onClick={scrollToTop}>{courseTitle}</Link></h5>
                    {/* <div className="star-rating float-none mb-15"> <span data-tm-width="90%"></span></div> */}
                    <p className='m-0'>{CourseBrief} </p>
                    <div className="campaign-bottom border-top clearfix pt-10 pb-10 mt-2 align-items-center">
                        <ul className="list-inline font-weight-600 float-start pr-0 mt-15">
                            <li className="text-theme-colored1 pr-0 mr-10">sessions: <span className="text-theme-colored2">{sessions}</span></li>
                        </ul>
                        <Link className="btn btn-xs btn-theme-colored2 font-weight-600 font-11 float-end flip mt-10" to={courseDetails} onClick={scrollToTop}>Read More</Link>
                    </div>
                </div>
            </div>
        </div>

    </>
}
